import { render, staticRenderFns } from "./DivisionNew.vue?vue&type=template&id=49599fa0"
import script from "./DivisionNew.vue?vue&type=script&lang=js"
export * from "./DivisionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports